export const tableOptions = {
  sortOptions: {
    enabled: true
  },
  paginationOptions: {
    enabled: true,
    mode: 'records',
    position: 'bottom',
    perPage: 15,
    perPageDropdown: [7, 15, 25, 50, 100],
    dropdownAllowAll: false,
    setCurrentPage: 1,
    nextLabel: 'Další',
    prevLabel: 'Předchozí',
    rowsPerPageLabel: 'Počet záznamů',
    ofLabel: 'z',
    allLabel: 'Vše',
  }
};

export const tableSearchOptions = {
  enabled: true,
  placeholder: 'Hledat…'
};

export const paginationFor = (rows, min = 15) => ({
  ...tableOptions.paginationOptions,
  enabled: Array.isArray(rows) && rows.length > min
});

export const czechDateColumn = {
  type: 'date',
  dateInputFormat: 'dd.MM.yyyy',
  dateOutputFormat: 'dd.MM.yyyy',
};
